import { render, staticRenderFns } from "./DashboardGovernmentPage.vue?vue&type=template&id=8bc113da&scoped=true"
import script from "./DashboardGovernmentPage.vue?vue&type=script&lang=js"
export * from "./DashboardGovernmentPage.vue?vue&type=script&lang=js"
import style0 from "./DashboardGovernmentPage.vue?vue&type=style&index=0&id=8bc113da&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc113da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bc113da')) {
      api.createRecord('8bc113da', component.options)
    } else {
      api.reload('8bc113da', component.options)
    }
    module.hot.accept("./DashboardGovernmentPage.vue?vue&type=template&id=8bc113da&scoped=true", function () {
      api.rerender('8bc113da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/use-metrics/pages/DashboardGovernmentPage.vue"
export default component.exports